import React from 'react';
import clsx from 'clsx';
import { TooltipReact } from 'common/components/tooltip';
import { useTranslation } from 'common/i18n/hooks';
import { StatisticallySignificant } from 'apps/experiments/src/types';
import { TooltipTextAlign } from 'common/components/tooltip/types';
import styles from './_chart.module.styl';
type ExperimentPageSummaryMetricsCategoryChartProps = {
  absMax: number;
  lift?: number;
  liftConfidence?: number;
  pValue?: number;
  statisticallySignificant?: StatisticallySignificant;
};
export function ExperimentPageSummaryMetricsCategoryChart(props: ExperimentPageSummaryMetricsCategoryChartProps) {
  const {
    absMax,
    lift = NaN,
    liftConfidence = NaN,
    pValue = NaN,
    statisticallySignificant = StatisticallySignificant.NO
  } = props;
  const diff = 2 * absMax;
  const i18n = useTranslation();
  const liftFormatter = new Intl.NumberFormat(i18n.language, {
    style: "percent",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  const pValueFormatter = new Intl.NumberFormat(i18n.language, {
    style: "decimal",
    minimumFractionDigits: 4,
    maximumFractionDigits: 4
  });
  const hasResults = !isNaN(lift);
  return <div className={styles.wrapper} data-sentry-component="ExperimentPageSummaryMetricsCategoryChart" data-sentry-source-file="_chart.tsx">
      <div className={styles.zero} style={{
      left: "".concat(absMax / diff * 100, "%")
    }} />
      {hasResults && <div className={clsx(styles.lift, {
      [styles.good]: statisticallySignificant === StatisticallySignificant.YES_POSITIVE,
      [styles.bad]: statisticallySignificant === StatisticallySignificant.YES_NEGATIVE
    })} style={{
      left: "".concat((lift - liftConfidence + absMax) / diff * 100, "%"),
      width: "".concat(2 * liftConfidence / diff * 100, "%")
    }}>
          <div className={styles.liftCenter} />
          <TooltipReact delayIn={250} textAlign={TooltipTextAlign.Start}>
            <div className={styles.tooltipLift}>
              {i18n.t("experiments.main.metrics.lift", {
            lift: liftFormatter.format(lift),
            confidence: liftFormatter.format(liftConfidence)
          })}
            </div>
            <div className={styles.tooltipPValue}>
              {i18n.t("experiments.main.metrics.p-value", {
            pValue: pValueFormatter.format(pValue)
          })}
            </div>
          </TooltipReact>
        </div>}
    </div>;
}